import { StateCreator } from 'zustand';

export interface MapUiSlice {
  isTourStarted: boolean;
  setIsTourStarted: (val: boolean) => void;

  showMapTourModal: boolean;
  setShowMapTourModal: (val: boolean) => void;

  isLoading: boolean;
  setIsLoading: (val: boolean) => void;
}

// --- Initial state for easy reset ---
export const mapUiInitialState = {
  isTourStarted: false,
  showMapTourModal: false,
  isLoading: true,
};

export const createMapUiSlice: StateCreator<MapUiSlice> = (set) => ({
  ...mapUiInitialState,

  setIsTourStarted: (val) => set({ isTourStarted: val }),
  setShowMapTourModal: (val) => set({ showMapTourModal: val }),
  setIsLoading: (val) => set({ isLoading: val }),
});
